<lib-n-fieldset icon="pi pi-calendar-plus" [title]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.NOVA_AUSENCIA' | translate">
  <form [formGroup]="form" class="n-form">
    <div class="grid">
      <!-- Data/Hora Início -->
      <div class="lg:col-6 md:col-6 sm:col-12 flex gap-2">
        <div class="flex-1">
          <lib-form-field
            [label]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.DATA_INICIO' | translate"
            controlName="dataInicio"
            [required]="true"
          >
            @if (deviceService.$isMobile()) {
            <input
              type="date"
              pInputText
              formControlName="dataInicio"
              class="w-full"
            />
            } @else {
            <p-datepicker
              formControlName="dataInicio"
              dateFormat="dd/mm/yy"
              [showButtonBar]="true"
              [placeholder]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.SELECIONAR_DATA' | translate"
              styleClass="w-full"
              appendTo="body"
            />
            }
          </lib-form-field>
        </div>
        <div class="w-7rem">
          <lib-form-field
            [label]="'GLOBAL.HORA' | translate"
            controlName="horaInicio"
            [required]="true"
          >
            <p-datepicker
              formControlName="horaInicio"
              [timeOnly]="true"
              placeholder="00:00"
              styleClass="w-full"
              appendTo="body"
            />
          </lib-form-field>
        </div>
      </div>

      <!-- Data/Hora Fim -->
      <div class="lg:col-6 md:col-6 sm:col-12 flex gap-2">
        <div class="flex-1">
          <lib-form-field
            [label]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.DATA_FIM' | translate"
            controlName="dataFim"
            [required]="true"
          >
            @if (deviceService.$isMobile()) {
            <input
              type="date"
              pInputText
              formControlName="dataFim"
              class="w-full"
            />
            } @else {
            <p-datepicker
              formControlName="dataFim"
              dateFormat="dd/mm/yy"
              [showButtonBar]="true"
              [placeholder]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.SELECIONAR_DATA' | translate"
              styleClass="w-full"
              appendTo="body"
            />
            }
          </lib-form-field>
        </div>
        <div class="w-7rem">
          <lib-form-field [label]="'GLOBAL.HORA' | translate" controlName="horaFim" [required]="true">
            <p-datepicker
              formControlName="horaFim"
              [timeOnly]="true"
              placeholder="00:00"
              styleClass="w-full"
              appendTo="body"
            />
          </lib-form-field>
        </div>
      </div>

      <!-- Motivo -->
      <div class="lg:col-12">
        <lib-form-field
          [label]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.MOTIVO' | translate"
          controlName="motivo"
          [required]="true"
          [helpText]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.MOTIVO_HINT' | translate"
        >
          <textarea
            pTextarea
            formControlName="motivo"
            [placeholder]="'BARDO_PROFISSIONAIS.AUSENCIAS_TAB.MOTIVO_PLACEHOLDER' | translate"
            maxlength="300"
            rows="3"
            class="w-full"
          ></textarea>
        </lib-form-field>
      </div>
    </div>
  </form>
</lib-n-fieldset>

<ng-template #footerTemplate>
  <div class="n-footer-actions">
    <p-button
      [label]="'GLOBAL.VOLTAR' | translate"
      icon="pi pi-arrow-left"
      severity="secondary"
      [outlined]="true"
      (onClick)="cancelar.emit()"
      [disabled]="$salvando()"
    />
    <p-button
      [label]="'GLOBAL.SALVAR' | translate"
      icon="pi pi-check"
      (onClick)="salvar()"
      [loading]="$salvando()"
      [disabled]="form.invalid || $salvando()"
    />
  </div>
</ng-template>
